/**
 * Shared math for glyph progress animation. `progress` is a caller-controlled
 * float where one unit is one full animation cycle (think of it as turns:
 * glyphs convert to an angle with TAU * progress). 0 is the resting drawing,
 * and the cycle wraps — approaching 1 returns to the resting drawing, so a
 * continuously incremented value loops seamlessly.
 */export const TAU=Math.PI*2;// Normalize an optional progress value into [0, 1): missing/invalid input is
// the resting position, and whole cycles wrap away.
export function wrapProgress(value){if(value==null||!Number.isFinite(value)){return 0;}return value-Math.floor(value);}